import React from 'react'

export type TFragmentWrapperProps = {
  name: string
  assetsUrl: string
  assetHash: string
}

const FragmentWrapper: React.FC<TFragmentWrapperProps> = (props) => {
  const ssrProps = getSsrProps(props)
  const jsAssetUrl = `${ssrProps.assetsUrl}/${ssrProps.name}/${ssrProps.name}-ui-fragment${ssrProps.assetHash}.js`
  const uiFragment = React.Children.map(props.children, (child) => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child, { ...props })
    }
    return child
  })
  return (
    <>
      {uiFragment} <script src={jsAssetUrl} />
    </>
  )
}

export const getSsrProps = (ssrProps: TFragmentWrapperProps): TFragmentWrapperProps => {
  if (BUILD_FLAG_IS_SERVER) {
    return ssrProps
  }
  const props = document.getElementById(`x-ui-fragment-${ssrProps.name}-state`)?.innerHTML ?? '{}'
  return JSON.parse(props)
}

export default FragmentWrapper
